<time-off-menu>
    <div class="main-container" *ngIf="hasFeatureAccess">
        <ng-container *ngIf="isLoading; else loaded">
            <ngx-skeleton-loader
                count="5"
                [theme]="{
                    'height.px': 50
                }"
            ></ngx-skeleton-loader>
        </ng-container>
        <ng-template #loaded>
            <div class="content" *ngIf="!isLoading">
                <div class="main-content">
                    <div *ngIf="this.viewState == eTimeOffViewState.ADD_TYPE">
                        <add-time-off [refreshListener]="this"></add-time-off>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.EDIT_TYPE">
                        <app-time-off-policies-types-editor
                            [timeOffType]="timeOffType"
                            [timeOffTypeList]="timeOffTypeList"
                            [policy]="policy"
                            [refreshListener]="this"
                            [currentCulture]="currentCulture"
                        >
                        </app-time-off-policies-types-editor>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.POLICY">
                        <time-off-policy [timeOffType]="timeOffType" [timeOffPolicyId]="timeOffPolicyId" [timeOffTypeList]="timeOffTypeList" [refreshListener]="this"></time-off-policy>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.LIST_TYPES" class="timeoff-workspace">
                        <header class="timeoff-toolbar">
                            <div class="header-copy">
                                <h4>{{ 'TimeOffTypesAndPolicies' | translate: {Default: "Time Off Types & Policies"} }}</h4>
                            </div>

                            <div class="toolbar-actions">
                                <!-- <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="goToTimeOffPolicy(null,null)">
                                    <mat-icon aria-hidden="false" class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                                    Add Policy
                                </button> -->

                                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="goToAdd()">
                                    <mat-icon aria-hidden="false" class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                                    Add Time Off Type
                                </button>
                            </div>
                        </header>

                        <div class="list-types-container">
                            <div class="filters-panel">
                                <mat-form-field class="search-field" appearance="outline">
                                    <input matInput
                                           [(ngModel)]="timeOffTypeSearchValue"
                                           placeholder="Search time off types...">
                                    <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="cards-container" *ngIf="(timeOffTypeList | timeOffTypeSearch:timeOffTypeSearchValue)?.length; else emptyTypes">
                                <mat-card class="timeoff-card" *ngFor="let timeOffType of timeOffTypeList | timeOffTypeSearch:timeOffTypeSearchValue">
                                    <div class="card-header">
                                        <div class="card-header-main" appPreventDoubleClick (throttledClick)="goToEdit(timeOffType)">
                                            <div class="type-badge" *ngIf="timeOffType.image">
                                                <img [src]="domSanitizer.bypassSecurityTrustUrl(timeOffType.image)" class="timeoff-type-icon" alt="{{ timeOffType.name }} icon" />
                                            </div>

                                            <div class="type-summary">
                                                <h3
                                                    setColor
                                                    [setColorRules]="[
                                                        {
                                                            color: 'primaryColour',
                                                            events: ['hover']
                                                        }
                                                    ]"
                                                >{{ timeOffType.name }}</h3>
                                                <p>{{ (timeOffType.policies?.length ?? 0) }} polic{{ (timeOffType.policies?.length ?? 0) === 1 ? 'y' : 'ies' }}</p>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            mat-icon-button
                                            aria-label="Delete time off type"
                                            appPreventDoubleClick
                                            (throttledClick)="showDeleteTypeConfirmation(timeOffType.id)"
                                            matTooltip="Delete"
                                            class="delete-button"
                                        >
                                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                                        </button>
                                    </div>

                                    <mat-card-content>
                                        <div class="policy-grid" *ngIf="(timeOffType.policies?.length ?? 0) > 0; else noPolicies">
                                            <button
                                                type="button"
                                                class="policy-tile"
                                                *ngFor="let policy of timeOffType.policies"
                                                appPreventDoubleClick
                                                (throttledClick)="goToTimeOffPolicy(timeOffType, policy)"
                                            >
                                                <div class="policy-name">{{ policy.name || 'Unnamed policy' }}</div>

                                                <div class="policy-meta">
                                                    <mat-chip
                                                        *ngIf="policy.accruedAt"
                                                        [ngClass]="{
                                                            'yellow-chip': policy.accruedAt?.id === 'StartOfPeriod',
                                                            'blue-chip': policy.accruedAt?.id === 'EndOfPeriod',
                                                        }"
                                                        selected
                                                    >
                                                        {{ policy.accruedAt?.name || 'Unnamed policy' }}
                                                    </mat-chip>
                                                </div>
                                            </button>
                                        </div>

                                        <ng-template #noPolicies>
                                            <div class="empty-policy-state">
                                                <p>No policies have been created for this time off type yet.</p>
                                                <button mat-stroked-button color="primary" appPreventDoubleClick (throttledClick)="goToTimeOffPolicy(timeOffType, null)">
                                                    <mat-icon class="material-icons-outlined">add</mat-icon>
                                                    Add policy
                                                </button>
                                            </div>
                                        </ng-template>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                            <ng-template #emptyTypes>
                                <div class="empty-state-container">
                                    <div class="empty-state-card">
                                        <h3>No time off types found</h3>
                                        <p>Try another search or add your first time off type.</p>
                                        <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="goToAdd()">
                                            <mat-icon class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                                            Add Time Off Type
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    
    </div>
    
    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</time-off-menu>
